import { render, staticRenderFns } from "./BoSoPopup.vue?vue&type=template&id=69f15132"
import script from "./BoSoPopup.vue?vue&type=script&lang=js"
export * from "./BoSoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports